import React, { useState } from 'react';
import { Button, Row, Col, Collapse, ListGroup, Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';

const Header = ({ title, buttons, description, listItems }) => {

    const [expanded, setExpanded] = useState(false);

    return (
        <div className="mb-4">

            {(title || buttons) && (
                <Row className="align-items-center">
                    <Col>
                        <div className="d-flex justify-content-between align-items-center flex-wrap">
                            {title && (
                                <div className="me-3">
                                    <h2 className="fw-bold mb-0">{title}</h2>
                                </div>
                            )}

                            {buttons && (
                                <div className="d-flex flex-wrap justify-content-end">
                                    {buttons.map((btn) => (
                                        <Button
                                            key={btn.id}
                                            variant={btn.variant}
                                            onClick={btn.onClick}
                                            className="me-2 mb-2"
                                        >
                                            {btn.icon && <FontAwesomeIcon icon={btn.icon} className="me-2" />}
                                            {btn.label}
                                        </Button>
                                    ))}
                                </div>
                            )}
                        </div>
                    </Col>
                </Row>
            )}

            {/* Preview text and "Show more" */}
            <Row className="mt-2">
                <Col>
                    <p className="mb-1">
                        {description}{' '}
                        <Button
                            variant="link"
                            size="sm"
                            className="p-0 align-baseline"
                            onClick={() => setExpanded(!expanded)}
                        >
                            {listItems ? (expanded ? 'Show Less' : 'Show More') : ''}
                        </Button>
                    </p>
                    <Collapse in={expanded}>
                        <Card className="mt-2">
                            <ListGroup variant="flush">
                                {listItems?.map((item, idx) => (
                                    <ListGroup.Item key={idx} className="d-flex align-items-center border-0">
                                        <FontAwesomeIcon icon={faCheckCircle} className="me-2" color={'#13a688'} />
                                        {item}
                                    </ListGroup.Item>
                                ))}
                            </ListGroup>
                        </Card>
                    </Collapse>
                </Col>
            </Row>
        </div>
    );
};

export default Header;
